import Route from '@core/components/Route';
import { RoutePath } from '@core/types/route';

import { InstructorTemplateProps } from '../../types/instructor-template';

export const WALDEMAR_LOTZ_CV: InstructorTemplateProps = {
  cv: [
    'geboren 1991 in Romanovka (Kasachstan)',
    'seit 2003 Kraftsport / Fitness',
    '2013 - 2017 Bundeswehr / Artillerietruppe',
    'seit 2017 Justiz Trier (EJHW)',
    '2017 - 2018 Escrima Club Trier (Martin Olk)',
  ],
  img: {
    alt: 'Waldemar Lotz, Mit-Gründer und Ausbilder von Systema Akademie Trier',
    src: '/img/profile-waldemar-lotz-250.jpg',
  },
  name: 'Waldemar Lotz',
  school: {
    name: 'Systema Akademie Trier',
    url: 'https://www.systema-trier.de',
  },
  systema: [
    <>
      seit 2018 <Route href={RoutePath.SolovevStyle}>Solovev Defense</Route> (
      <Route href={RoutePath.FalkoZander}>Falko Zander</Route>)
    </>,
    <>
      seit 2018 <Route href={RoutePath.KampkunstPu}>Privatschüler</Route> von Falko Zander
    </>,
    <>Mit-Gründer, Systema Akademie Trier</>,
    <>
      <Route href={RoutePath.KampfkunstInstructorProgram}>Instructor</Route>, Solovev Defense
    </>,
    <>
      <Route href={RoutePath.KampfkunstRanking}>7. Schülergrad</Route>, Solovev Defense
    </>,
  ],
};
